import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const Footer = () => {
  const currentYear = new Date().getFullYear();
  // Community link config — single fetch on mount; failures fall back to
  // hiding the link rather than breaking the footer.
  const [community, setCommunity] = useState({ footer_enabled: false, footer_label: 'Join Community' });

  useEffect(() => {
    axios
      .get(`${API}/api/pages/community-settings`)
      .then(({ data }) => setCommunity({
        footer_enabled: !!data.footer_enabled,
        footer_label: data.footer_label || 'Join Community',
      }))
      .catch(() => {/* silently hide on failure */});
  }, []);

  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
          {/* Copyright */}
          <div className="text-sm text-gray-500">
            © HelmTorq 2023-{currentYear}. All rights reserved.
          </div>
          
          {/* Links */}
          <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-1 text-sm">
            <Link 
              to="/privacy-policy" 
              className="text-gray-500 hover:text-gray-700 transition-colors"
            >
              Privacy Policy
            </Link>
            <Link 
              to="/terms-of-use" 
              className="text-gray-500 hover:text-gray-700 transition-colors"
            >
              Terms of Use
            </Link>
            <Link 
              to="/refund-policy" 
              className="text-gray-500 hover:text-gray-700 transition-colors"
            >
              Refund Policy
            </Link>
            <Link 
              to="/contact-us" 
              className="text-gray-500 hover:text-gray-700 transition-colors"
            >
              Contact Us
            </Link>
            {community.footer_enabled && (
              <a
                href={`${API}/api/community/go`}
                className="text-[#0A7EA4] hover:text-[#0A7EA4]/80 font-medium transition-colors"
                data-testid="footer-community-link"
              >
                {community.footer_label}
              </a>
            )}
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
